import { create } from 'zustand';
import type { AccountResponse } from '../api/types';

export type Account = AccountResponse;

type AccountState = {
  account: Account | null;
  setAccount: (account: Account) => void;
  clearAccount: () => void;
};

export const useAccountStore = create<AccountState>(set => ({
  account: null,
  setAccount: account => set({ account }),
  clearAccount: () => set({ account: null }),
}));
